import { render, staticRenderFns } from "./TableFolder.vue?vue&type=template&id=3d4d9cd8&"
import script from "./TableFolder.vue?vue&type=script&lang=ts&"
export * from "./TableFolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports